import {
  Dialog as HeadlessDialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'

// Dialog (migrated off Tailwind in Wave 47q). Vanilla CSS classes
// own all layout and styling — see .studio-dialog-* rules in
// studio.css.

export function Dialog({ open, onClose, title, children, footer }) {
  return (
    <HeadlessDialog
      open={open}
      onClose={onClose}
      className="studio-dialog-root"
    >
      <DialogBackdrop className="studio-dialog-backdrop" />
      <div className="studio-dialog-positioner">
        <DialogPanel className="studio-dialog-panel">
          <div className="studio-dialog-head">
            <DialogTitle className="studio-dialog-title">{title}</DialogTitle>
            <button
              type="button"
              className="studio-dialog-close"
              onClick={() => onClose(false)}
              aria-label="Close dialog"
            >
              <XMarkIcon width={16} height={16} aria-hidden="true" />
            </button>
          </div>
          <div className="studio-dialog-body">{children}</div>
          {footer ? <div className="studio-dialog-footer">{footer}</div> : null}
        </DialogPanel>
      </div>
    </HeadlessDialog>
  )
}
